import styled from 'styled-components';

export const StyledContent = styled.div`
  .identity__for-canadians-header {
    margin-top: 32px;
  }
  .identity__for-canadians-sub-header {
    margin: 32px 0;
  }
`;
